import { Link } from "react-router-dom"
import { routes } from "../../utils/utils.routes"
import { FiArrowRight, FiMapPin } from "react-icons/fi";

const MapI = FiMapPin as any;
const ArrowI = FiArrowRight as any;

export const UpcomingEvents: React.FC<{ events: EventItem[], byMonth: Record<string, EventItem[]>, activities: EventItem[], showAside?: boolean }> = ({ events, byMonth, activities, showAside = true }) => {
    return (
        <div className={`events-layout ${showAside ? "" : "events-layout--no-aside"}`}>
            <div className="events-timeline">
                {events.length === 0 ? (
                    <p className="events-empty">Aucun événement pour le moment.</p>
                ) : (
                    Object.entries(byMonth).map(([month, list]) => (
                        <section key={month} className="events-month-group">
                            <h3 className="events-month-group__title">{month}</h3>
                            <ul className="events-list">
                                {list.map((ev) => (
                                    <li key={ev.id}>
                                        <Link to={`${routes.ARTICLESDETAILS}/${ev.slug}`}
                                            className="events-list__item"
                                            data-testid={`event-card-${ev.slug}`}
                                        >
                                            <div className="events-list__date">
                                                <span className="events-list__day">
                                                    {new Date(ev.eventDate || ev.publishedAt || ev.createdAt || "").getDate()}
                                                </span>
                                                <span className="events-list__mon">
                                                    {new Date(ev.eventDate || ev.publishedAt || ev.createdAt || "")
                                                        .toLocaleDateString("fr-FR", { month: "short" })
                                                        .toUpperCase()}
                                                </span>
                                            </div>
                                            <div className="events-list__content">
                                                <h4>{ev.title}</h4>
                                                {ev.location && (
                                                    <span className="events-list__loc">
                                                        <MapI size={12} /> {ev.location}
                                                    </span>
                                                )}
                                                {ev.excerpt && <p>{ev.excerpt.slice(0, 120)}…</p>}
                                            </div>
                                            <ArrowI className="events-list__arrow" size={18} />
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </section>
                    ))
                )}
            </div>

            {showAside && (
                <aside className="events-aside">
                    <div className="events-aside__card">
                        <h3>Liens utiles</h3>
                        <ul>
                            <li><Link to={routes.SCHEDULES}>Horaires des cours</Link></li>
                            <li><Link to={routes.TENDERS}>Appels d&apos;offres</Link></li>
                            <li><Link to={routes.ARTICLES}>Actualités</Link></li>
                            <li><Link to={routes.FAQ}>FAQ</Link></li>
                            <li><Link to={routes.GUIDE_INSCRIPTION}>Guide d&apos;inscription</Link></li>
                        </ul>
                    </div>

                    {activities.length > 0 && (
                        <div className="events-aside__card">
                            <h3>Activités récentes</h3>
                            <ul className="events-aside__mini">
                                {activities.slice(0, 5).map((a) => (
                                    <li key={a.id}>
                                        <Link to={`${routes.ARTICLESDETAILS}/${a.slug}`}>{a.title}</Link>
                                        <time>
                                            {new Date(a.publishedAt || a.createdAt || "").toLocaleDateString("fr-FR")}
                                        </time>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </aside>
            )}
        </div>
    )
}